<label
  class="font-size-headline color-city-blue"
  id="{{ question.uniqueHtmlIdentifier }}"
  >{{ question.question.caption }}</label
>
@if (question.question.isRequired) {
<mat-label class="color-city-red"> *</mat-label>
} @for (option of question.question.additionalPropertiesParsed.Options; track
option; let indexOfelement = $index) {
<div>
  <div fxLayout="row">
    <div fxLayout="column" style="padding-right: 0.5em">
      <mat-checkbox
        value="{{ option }}"
        (change)="setAnswer($event)"
        checked="{{ indexSelected[indexOfelement] }}"
        id="questionOption{{ question.uniqueHtmlIdentifier }}{{
          indexOfelement
        }}"
      >
      </mat-checkbox>
    </div>
    <div fxFlex="80" fxLayout="column" style="margin-top: 0.2em">
      <span class="checkbox-textwrap color-dark-blue font-size-small-text">
        {{ option }}
      </span>
    </div>
  </div>
  <div fxlayout="row">
    @if (question.question.isRequired && !(question.answer)) {
    <mat-error>{{ "radiobutton_required" | translate }}</mat-error>
    }
  </div>
</div>
}
